import { AmbitoDTO } from '@framework/api-client';
import { useMemo } from 'react';
import { getIndentScopes } from './getIndentScopes';
import { normalizeScopesTreeData } from './normalizeScopesTreeData';

/**
 * Hook per ottenere i dati degli ambiti in modo che siano compatibili con la TreeSelect.
 */
export function useScopesData(scopes?: AmbitoDTO[] | null) {
  const indentScopes = useMemo(() => {
    const rawScopes = scopes ?? [];
    return getIndentScopes(rawScopes);
  }, [scopes]);

  const treeDataScopes = useMemo(
    () => normalizeScopesTreeData(indentScopes),
    [indentScopes],
  );

  return treeDataScopes;
}
